export default function Configure($stateProvider) {
    $stateProvider.state('societes-locataire', {
        parent: 'common',
        url: '/societes-locataire',
        views: {
            common: {
                template: '<ui-view></ui-view>'
            }
        },
        ncyBreadcrumb: {
            label: '{{ "LAYOUT.NAVIGATION.FONCIER" | translate }}'
        }
    });

    $stateProvider.state('societes-locataire.list', {
        url: '/list',
        template: '<societes></societes>',
        rights: { domain: 'societesREMOVE', right: 'read', application: 'qse' },
        params: {
            genre: '128'
        },
        ncyBreadcrumb: {
            label: '{{ "SOCIETES.BREADCRUMBS.SOCIETES_LOCATAIRE_LIST" | translate}}'
        },
        navigation: {
            menu: 'foncier_no_category',
            translate: 'SOCIETES.BREADCRUMBS.SOCIETES_LOCATAIRE_LIST',
            order: 3
        },
        search: 'SOCIETES.BREADCRUMBS.SOCIETES_LOCATAIRE_LIST'
    });

    $stateProvider.state('societes-locataire.niveaux', {
        url: '/niveaux',
        template: '<societe-config-niveaux></societe-config-niveaux>',
        rights: { domain: 'nivh', right: 'read' },
        params: {
            genre: '128'
        },
        ncyBreadcrumb: {
            // on décide que la liste est le parent des autres states
            // afin d'afficher societes > niveaux
            parent: 'societes-locataire.list({genre: "128"})',
            label: '{{ "SOCIETES.BREADCRUMBS.SOCIETE_NIVEAUX" | translate }}'
        }
    });

    $stateProvider.state('societes-locataire.list.detail', {
        url: '/{id}',
        template: '<societe-detail></societe-detail>',
        rights: { domain: 'societes', right: 'read' },
        params: {
            genre: '128'
        },
        ncyBreadcrumb: {
            parent: 'societes-locataire.list({genre: "128"})',
            label: '{{ "SOCIETES.BREADCRUMBS.SOCIETE_DETAIL" | translate }}'
        }
    });

    $stateProvider.state('societes-locataire.new', {
        url: '/new',
        template: '<societe-form></societe-form>',
        rights: { domain: 'societes', right: 'create' },
        params: {
            genre: '128'
        },
        ncyBreadcrumb: {
            parent: 'societes-locataire.list({genre: "128"})',
            label: '{{ "SOCIETES.BREADCRUMBS.SOCIETE_LOCATAIRE_NEW" | translate}}'
        },
        search: 'SOCIETES.BREADCRUMBS.SOCIETE_LOCATAIRE_NEW'
    });

    $stateProvider.state('societes-locataire.edit', {
        url: '/{id}/edit',
        template: '<societe-form></societe-form>',
        rights: { domain: 'societes', right: 'update' },
        params: {
            genre: '128'
        },
        ncyBreadcrumb: {
            parent: 'societes-locataire.list({genre: "128"})',
            label: '{{ "SOCIETES.BREADCRUMBS.SOCIETE_LOCATAIRE_EDIT" | translate }}'
        }
    });

    $stateProvider.state('societes-locataire.newType', {
        url: '/new-type',
        template: '<type-form></type-form>',
        rights: { domain: 'types', right: 'create' },
        params: {
            parentState: 'societes-locataire.new',
            genre: '128'
        },
        ncyBreadcrumb: {
            parent: 'societes-locataire.new',
            label: '{{ "TYPES.BREADCRUMBS.TYPE_NEW" | translate}}'
        }
    });
}

Configure.$inject = ['$stateProvider'];
